export default __webpack_public_path__ + "static/media/postfinance.5394cb7f.svg";